<template>
  <el-dialog :visible="visible" title="商品信息" @close="close" top="5vh">
    <el-form :inline="true" :model="formInline" label-position="left" class="detail-spider-dialog" ref="ruleForm"
      :rules="rules">
      <!-- <el-form-item label="商品采购链接:" prop="productLink">
        <el-input :disabled="!detailInfo.enableEditProp || detailInfo.inboundStatus != 0"
          v-model="formInline.productLink"></el-input>
        <el-button :disabled="!detailInfo.enableEditProp || detailInfo.inboundStatus != 0" type="primary"
          @click="search">查询</el-button>
        <el-button :disabled="!detailInfo.enableEditProp || detailInfo.inboundStatus != 0" @click="reset">重置</el-button>
      </el-form-item> -->
      <el-form-item label="库存类型" required label-width="120px" prop="skuType">
        <el-radio-group v-model="formInline.skuType" :disabled="true">
          <el-radio-button :label="0">线上商品</el-radio-button>
          <el-radio-button :label="1">OEM</el-radio-button>
          <el-radio-button :label="2">线下商品</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商品SKU" required label-width="120px" prop="productSku">
        <el-input  :disabled="!detailInfo.enableEditProp || detailInfo.inboundStatus != 0"
          v-model="formInline.productSku"></el-input>
        <el-button :disabled="!detailInfo.enableEditProp || detailInfo.inboundStatus != 0" type="primary"
          @click="search">查询</el-button>
        <el-button :disabled="!detailInfo.enableEditProp || detailInfo.inboundStatus != 0" @click="reset">重置</el-button>
      </el-form-item>
      <el-form-item label="商品规格:" required label-width="120px" prop="productProp">
        <el-input  :disabled="!detailInfo.enableEditProp || detailInfo.inboundStatus != 0"
          v-model="formInline.productProp"></el-input>
        <!-- <el-select v-if="!detailInfo.enableEditProp || detailInfo.inboundStatus != 0" :value="detailInfo.productProp"
          disabled style="width:100%;"></el-select>
        <el-select v-else v-model="formInline.productSku" filterable style="width:100%;">
          <el-option :value="item.productSku" v-for="(item, index) in skuList" :key="index"
            :label="item.productPropertiesName.replace(/[+-]?\d+:[+-]?\d+:/, '')"></el-option>
        </el-select> -->
      </el-form-item>
      <div class="dialog-btn">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { goodsDetailAndSaveByUrlApi, updatePropApi, getInfoBySku, updatePropBySku } from '@/apis/inHouse'
export default {
  name: "detailSpider",
  data() {
    return {
      visible: false,
      formInline: {
        productSku: '',
        productLink: '',
        skuType: 0,
        productProp: ''
      },
      skuList: [],
      rules: {
        productLink: [
          { required: true, message: '商品采购链接不能为空', trigger: 'blur' }
        ],
        productSku: [
          { required: true, message: '商品SKU不能为空', trigger: 'blur' }
        ],
        productProp: [
          { required: true, message: '商品规格不能为空', trigger: 'blur' }
        ],
      },
      detailInfo: {}
    };
  },
  computed: {
  },
  watch:{
    "formInline.skuType":{
      handler: function (newVal) {
        // this.formInline.productSku = ''
        // this.formInline.productProp = ''
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate()
        })
      }
    }
  },
  methods: {
    close() {
      this.visible = false
    },
    open(record) {
      console.log(record)
      this.visible = true
      this.detailInfo = record
      // this.skuList = record.productPropList
      // this.formInline.productLink = record.productLink
      this.formInline.productSku = record.productSku
      this.formInline.productProp = record.productProp
      this.formInline.skuType = record.skuType
    },
    submit() {
      if (!this.detailInfo.enableEditProp || this.detailInfo.inboundStatus != 0) {
        this.close()
        return
      }
      this.$refs.ruleForm.validate((valid) => {
        console.log(valid)
        if (valid) {
          // let productProp = '';
          // this.skuList.forEach((item) => {
          //   if (item.productSku === this.formInline.productSku) {
          //     productProp = item.productPropertiesName
          //   }
          // })
          updatePropBySku({
            "inboundItemId": this.detailInfo.id,
            "productCode": this.detailInfo.productCode,
            "productImg": this.detailInfo.productImg,
            "productLink": this.detailInfo.productLink,
            "productName": this.detailInfo.productName,
            "productProp": this.formInline.productProp,
            "productPropList": this.detailInfo.productPropList,
            "productSku": this.formInline.productSku,
            "importOemClassificationId": this.detailInfo.importOemClassificationId,
            "skuType": this.formInline.skuType
          }).then(() => {
            this.$message.success('修改成功！')
            this.$emit('refresh')
            this.visible = false
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset() {
      this.$refs.ruleForm.resetFields();
      this.skuList = []
    },
    search() {
      if (!this.formInline.productSku) {
        return
      }
      getInfoBySku({
        productSku: this.formInline.productSku,
        skuType: this.formInline.skuType
      }).then((res) => {
        if(res.code == 0){
          this.formInline.productProp = res.data.productProp
          // this.formInline.skuType = res.data.skuType
            this.detailInfo = {
            ...this.detailInfo,
            ...res.data,
            productName: res.data.productName,
            productImg: res.data.productImg,
            importOemClassificationId: res.data.importOemClassificationId
          }
        }
      })
      // goodsDetailAndSaveByUrlApi({
      //   detailUrl: this.formInline.productLink,
      //   customerId: this.$store.getters.getAuthInfo.userId
      // }).then((res) => {
      //   if (res.code == 0) {
      //     res.data.skuList.forEach((item) => {
      //       item.productPropertiesName = item.productPropertiesName.replace(/[+-]?\d+:[+-]?\d+:/, '')
      //     })
      //     this.detailInfo = {
      //       ...this.detailInfo,
      //       ...res.data,
      //       productName: res.data.productTitle,
      //       productImg: res.data.productMainImg
      //     }
      //     this.skuList = res.data.skuList
      //     this.formInline.productSku = ''
      //   }
      // })
    }
  },
};
</script>

<style lang="less">
.detail-spider-dialog {

  .el-form-item {
    display: flex !important;
    text-align: left;
    align-items: center;
    justify-content: space-between;
    margin-right: 0 !important;

    .el-form-item__label {
      width: 150px;
    }

    .el-form-item__content {
      flex: 1;
      display: flex;

      .el-input {
        flex: 1;
        margin-right: 20px;
      }
    }
  }

  .dialog-btn {
    margin-top: 150px;
    text-align: right;
    padding-bottom: 10px;
  }
}
</style>
